var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIconOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "white",
    fill: "none",
    strokeWidth: 20,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 90,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 50,
    x2: 90,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 90,
    x2: 90,
    y2: 90
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconOpen);
export default __webpack_public_path__ + "static/media/menu-icon-open.157880029daa22b503996eec27608b28.svg";
export { ForwardRef as ReactComponent };